import AdminApi from '../services/api';
import swal from 'sweetalert2';
import Loc from "../services/localization";

/* init */

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default{

    props: ['show', 'options'],

    data() {
        return {
            locale: LocService,
            isLoading: false,
            selectedOption: '',
            hasError: '',
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val){

            }
        },
    },

    methods: {
        close() {
            this.reset();
            this.$topnavbar.$emit('closeChoseImei')
        },
        keymonitor: keymonitor,
        reset:reset,
        load: load,
        onSelectedOptions: onSelectedOptions,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile(){
            if(this.isMobile()){
                return 'modal--small'
            }else {
                return 'modal--medium'
            }
        },
        modalStyle(){
            if(this.isMobile()){
                return 'color: white; background-color: black;'
            }else {
                return ''
            }
        },
        mainDivStyle(){
            if(this.isMobile()){
                return 'background-color: #1C242D; color: #ffffff;'
            }else {
                return 'background-color: #1C242D; color: #ffffff;'
            }
        },
        tableStyle(){
            if(this.isMobile()){
                return 'height: 400px !important; overflow: auto; padding: 15px;';
            }
            return 'height: 600px !important; overflow: auto; padding: 15px;';
        }
    }
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.load();
    }
}

function load() {

}

function reset(){

}


function onSelectedOptions(option){
    this.$topnavbar.$emit('selectedImei', option)
}


// WEBPACK FOOTER //
// ./src/modals/ChooseImeiAfterPicture.js